import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showMainNavigation: false
  },
  mutations: {
    mainNavigation (state, status) {
      state.showMainNavigation = status
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js